/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { isEqual } from 'lodash'

import { hasNext } from './preconditions'

import type { DifferenceCheck } from './types'

export const diffVersion: DifferenceCheck = {
  preconditions: [hasNext],
  check: ({ current, next, sliderInstanceType }) => {
    if (!next?.[sliderInstanceType].version) {
      return []
    }

    const currentVersion = current?.[sliderInstanceType].version
    const nextVersion = next?.[sliderInstanceType].version

    if (isEqual(nextVersion, currentVersion)) {
      return []
    }

    return [
      {
        type: `version-changed`,
        target: sliderInstanceType,
        meta: {
          currentVersion,
          nextVersion,
        },
      },
    ]
  },
}
